export const MIN_LENGTH = 7
export const MIN_UPPERCASE = 1
export const MIN_LOWERCASE = 1
export const MIN_NUMBER = 1

const patternLowerCase = new RegExp(`(?<lowercase>[a-z]{${MIN_LOWERCASE},})`)
const patternUpperCase = new RegExp(`(?<uppercase>[A-Z]{${MIN_UPPERCASE},})`)
const patternDigits = new RegExp(`(?<digits>[0-9]{${MIN_NUMBER},})`)

export const validatePassword = (value: string = '') => {
    const hasDigits = Boolean(patternDigits.exec(value ?? '')?.groups?.digits)
    const hasLowerCase = Boolean(
        patternLowerCase.exec(value ?? '')?.groups?.lowercase,
    )
    const hasUpperCase = Boolean(
        patternUpperCase.exec(value ?? '')?.groups?.uppercase,
    )
    const hasLength = value ? Boolean(value?.length >= MIN_LENGTH) : false

    const isValid = hasDigits && hasLength && hasLowerCase && hasUpperCase

    return {
        hasDigits,
        hasLength,
        hasLowerCase,
        hasUpperCase,
        isValid,
    }
}

export const usePasswordStrength = (value: string) => validatePassword(value)
